var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"i8K-iFuxfg2u1GGG10-LC"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["emak-frontend@webranking-srl"]={id:"i8K-iFuxfg2u1GGG10-LC"};
      